import {
  LOAD_ALL_CENTER_PRODUCT_PRICE,
  LOAD_SINGLE_CENTER_PRODUCT_PRICE,
} from "./PriceList.saga";

export const loadAllCenterProductPrice = (payload) => ({
  type: LOAD_ALL_CENTER_PRODUCT_PRICE.LOADING,
  payload,
});

export const loadSingleCenterProductPrice = (payload) => ({
  type: LOAD_SINGLE_CENTER_PRODUCT_PRICE.LOADING,
  payload,
});
